import { Action } from 'redux'
import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, delay, map, Observable, of, switchMap } from 'rxjs'
import { getHub } from '../../../helpers/hub'
import { addToast } from '../../toasts/actions'
import { logError } from '../../ws/actions'
import { addData, FetchAction, fetchFail } from './actions'
import { ExternalLiquidityStats } from './types'

const fetchQueueStatsEpic: Epic<Action> = (action$) =>
  action$.pipe(
    ofType('externalLiquidityStats.fetchData'),
    delay(1000),
    switchMap((action: FetchAction) => {
      const getExternalLiquidityStats$: Observable<ExternalLiquidityStats[]> =
        getHub().invoke<ExternalLiquidityStats[]>(
          'GetExternalLiquidityStats',
          action.payload.venues,
          action.payload.security
        )
      return getExternalLiquidityStats$.pipe(
        map((stats) => {
          return addData(stats)
        }),
        catchError((err) =>
          of(
            fetchFail(err),
            logError(err),
            addToast({
              message: `${err.message}`,
              options: {
                toastId: `externalLiquidityStats-error`,
                type: 'error'
              }
            })
          )
        )
      )
    })
  )

export default combineEpics(fetchQueueStatsEpic)
